import {
  GET_ANSWER_AGENT_PROFILE,
  GET_ANSWER_AGENT_PROFILE_SUCCESS,
  GET_ANSWER_AGENT_PROFILE_ERROR,
  QUOTE_FUNNEL_QUESTIONS,
  QUOTE_FUNNEL_QUESTIONS_SUCCESS,
  QUOTE_FUNNEL_QUESTIONS_ERROR,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR,
  GET_QUOTE_FUNNEL_SESSION_ID,
  GET_QUOTE_FUNNEL_SESSION_ID_SUCCESS,
  GET_QUOTE_FUNNEL_SESSION_ID_ERROR,
  CREATE_QUOTE_FORM_VISIT_SUCCESS,
  CREATE_QUOTE_FORM_VISIT_ERROR,
  UPDATE_QUOTE_FORM_VISIT_SUCCESS
} from "./actionTypes"

export const getAnswerAgentProfile = (payload) => ({
  type: GET_ANSWER_AGENT_PROFILE,
  payload: payload
})

export const getAnswerAgentProfileSuccess = (payload) => ({
  type: GET_ANSWER_AGENT_PROFILE_SUCCESS,
  payload: payload
})

export const getAnswerAgentProfileError = (error) => ({
  type: GET_ANSWER_AGENT_PROFILE_ERROR,
  payload: error
})

export const getQuoteFunnelQuestions = (payload) => ({
  type: QUOTE_FUNNEL_QUESTIONS,
  payload: payload
})

export const getQuoteFunnelQuestionsSuccess = (payload) => ({
  type: QUOTE_FUNNEL_QUESTIONS_SUCCESS,
  payload: payload
})

export const getQuoteFunnelQuestionsError = (error) => ({
  type: QUOTE_FUNNEL_QUESTIONS_ERROR,
  payload: error
})

export const updateQuoteFunnelQuestionsWithAnswers = (payload, additional_info, history) => ({
  type: UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS,
  payload: { payload, additional_info, history }
})

export const updateQuoteFunnelQuestionsWithAnswersSuccess = (payload) => ({
  type: UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS,
  payload: payload
})

export const updateQuoteFunnelQuestionsWithAnswersError = (error) => ({
  type: UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR,
  payload: error
})


export const getQuoteFunnelSessionId = (payload) => ({
  type: GET_QUOTE_FUNNEL_SESSION_ID,
  payload: payload
})

export const getQuoteFunnelSessionIdSuccess = (payload) => ({
  type: GET_QUOTE_FUNNEL_SESSION_ID_SUCCESS,
  payload: payload
})

export const getQuoteFunnelSessionIdError = (error) => ({
  type: GET_QUOTE_FUNNEL_SESSION_ID_ERROR,
  payload: error
})

export const createQuoteFormVisitSuccess = (payload) => ({
  type: CREATE_QUOTE_FORM_VISIT_SUCCESS,
  payload: payload
})

export const createQuoteFormVisitError = (error) => ({
  type: CREATE_QUOTE_FORM_VISIT_ERROR,
  payload: error
})

export const updateQuoteFormVisitSuccess = (payload) => ({
  type: UPDATE_QUOTE_FORM_VISIT_SUCCESS,
  payload: payload
})